import {useEffect, useState} from 'react';
import { useThemeMode } from "../../_metronic/partials";

export const useResolvedThemeMode = () => {
  const theme = useThemeMode();
  const [mode, setMode] = useState('light');

  useEffect(() => {
    const systemDark = window.matchMedia('(prefers-color-scheme: dark)');

    const updateMode = () => {
      if (theme.mode === 'system') {
        setMode(systemDark.matches ? 'dark' : 'light');
      } else {
        setMode(theme.mode);
      }
    };

    updateMode(); // одразу при завантаженні або зміні theme

    if (theme.mode === 'system') {
      systemDark.addEventListener('change', updateMode);
      return () => systemDark.removeEventListener('change', updateMode);
    }
  }, [theme.mode]);

  return mode;
};
